import React from 'react';
import './navs-header.css'
const Navsheader = (props) => {
    return ( 
        
    <li className='navlheader'>{props.title}</li>
     );
}
 
export default Navsheader;